import { UndoRedoState } from 'editor/src/store/editorModules/undoRedo/types';

const popPreviousStateReducer = (state: UndoRedoState) => {
  state.previous.pop();
};

export default popPreviousStateReducer;
